import RelatedContent from './relatedContent.component';

export default RelatedContent;
